import {CellRenderContext, IGridCellRenderer} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {CellView} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/CellView';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./FrameCell.less');
const cx = classnames.bind(styles);

export class FrameCellRenderer implements IGridCellRenderer
{
    render(ctx:CellRenderContext):React.ReactElement<any>
    {
        const props:any = {
            style:{},
            key:ctx.key,
            ctx:ctx
        };

        // return React.createElement(CellView, {style:{}, key:ctx.key, ctx:ctx});
        return React.createElement(CellView, props);

        // const aCell = ctx.cell as FrameCell;
        // const displayString = aCell.toDisplayString();
        //
        // return  <div key={ctx.key}
        //              style={ctx.style}
        //              className={cx(ctx.className, 'frameCell')}
        //              ref={ctx.ref}
        //         >
        //                  {displayString}
        //          </div>;
    }
}
